import { TwToastPlugin } from '../design-system/TwToast';
import { registerListKit } from '../components/shared/list-detail/registerListKit';

/**
 * The Vue setup every entry (customer app.js, Sophia main.js) needs, so a change to it is made once. Modules
 * app.js loads lazily are passed in; importing them here would pull them into its main bundle.
 */
export function installSharedVue({ Vue, axios, uiLibrary, PiniaVuePlugin, vueMoment, moment }) {
  Vue.use(uiLibrary);
  Vue.use(TwToastPlugin);
  registerListKit(Vue);
  Vue.use(PiniaVuePlugin);
  Vue.use(vueMoment, { moment });
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}
